<template>
<div>
    <div class="ibox animated fadeInRightBig">
        <div class="ibox-title">
            <h3>Novo Usuário <i class="fa fa-user-circle" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
        </div>
        <form id="form">
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-4">
                        <label for="name"><span class="required">*</span> Nome:</label>
                        <input type="text" class="form-control" name="name" v-model="admins.name" id="name" placeholder="Nome do usuário">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="email"><span class="required">*</span> E-mail</label>
                        <input type="email" class="form-control" name="email" v-model="admins.email" id="email" placeholder="nome@empresa.com.br">
                    </div>
                    <div class="form-group col-md-3">
                        <label for="password"><span class="required">*</span> Senha</label>
                        <input type="password" name="password" class="form-control" id="password" placeholder="***********" v-model="admins.password">
                    </div>
                </div>
            </div>

             <div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/admins" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                admins: {
                    name: '',
                    email: '',
                    password: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const api = this.$store.state.api + 'admins';
                const self = this;

                let form  = new FormData();

                form.append('name', self.admins.name);
                form.append('email', self.admins.email);
                form.append('password', self.admins.password);

                self.$http.post(api, form)
                    .then((response) => {
                        self.admins = response.data.data;
                        self.tableData = self.admins;


                        self.$message('Sucesso', `Administrador cadastrado com sucesso`, 'success');

                        self.admins = {

                            name: '',
                            email: '',
                            password: '',
                        };
                         this.$router.push('/admins');

                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });


            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Add.vue